'use strict';

module.exports = function(ngModule) {
	console.log('Loading SiteVisit API');
	ngModule.factory('SiteVisitApi', ['$http', function ($http) {
		var base_url = __API__;
		// Hack to support hostname alias for sitevisit
		// Make sure API uses the same hostname as web app to aovoid CORS issues
		if (location.hostname === 'localhost') {
			var base_url = location.protocol+'//' + location.hostname+'/proxy/service/sitevisit3'
		} else {
			var base_url = location.protocol+'//' + location.hostname+'/service/sitevisit3'
		}

		var errorHandler = function(error) {
			try {
				console.log("siteVisit.api", error);
				switch (error.data.errorMessage) {
					case (error.data.errorMessage.match(/^Mobile number '[0-9]+' does not match/) || {}).input:
						return {status: 'UNKNOWN'};
					case (error.data.errorMessage.match(/^Invalid access code/) || {}).input:
						return {status: 'INVALID_CODE'};
					case (error.data.errorMessage.match(/^Incorrect autentication code/) || {}).input:
						return {status: 'INVALID_CODE'};
					case (error.data.errorMessage.match(/^Invalid value '[^.]+ passed in for /) || {}).input:
						return {status: 'INVALID_CASE'};
					case (error.data.errorMessage.match(/^Could not find any active WO\/DMF\/PAIN with reference number/) || {}).input:
						return {status: 'INVALID_CASE'};
					default:
						console.log(error);			
						return {status: "SERVER_ERROR"};
				}
			} catch(error) {
				console.log(error);
				return {status: "SERVER_ERROR"};
			}
		};

		return {
			// Call CASDM and check if the provided caseId is a valid CASDM case id 
			checkId: function(visitCase) {
				console.log("checkId request:", visitCase)
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: {
						op: 'checkId',
						case: visitCase
					}	
				};
	
				return $http(req)
				.then(
					function(result) {
						console.log("checkId result:", Boolean(result.data.status > 0));
						return Boolean(result.data.status > 0);
					},
					function(error) {
						return errorHandler(error);
					}
				)
			},
			
			// Call CASDM and request an authentication access code be sent via SMS to visitor 
			authInit: function (visitor, visitCase, position, client) {
				console.log("authInit request:", visitor, visitCase, position, client)
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: {
						op: 'authInit',
						visitor: visitor,
						case: visitCase,
						position: position,
						client: client
					}
				}
				return $http(req)
				.then(
					function(result) {
						console.log("authInit result:", result.data);
						return result.data;
					},
					function(error) {
						return errorHandler(error);
					}
				)
			},
			
			// Call CASDM with the access code sent vistor via SMS
			authConfirm: function (authCode, position, visitId) {
				console.log("authConfirm request:", authCode, position, visitId)
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: {
						op: 'authConfirm',
						authCode: authCode,
						position: position,
						visitId: visitId
					}
				}
				return $http(req)
				.then(
					function(result) {
						console.log("authConfirm result:", result.data);
						return result.data;
					},
					function(error) {
						return errorHandler(error);
					}
				)
			},
			
			// Call CASDM to notify on-site
			onSite: function (visitId, checkIn, checkOut, position) {
				console.log("onSite request:", visitId, checkIn, checkOut, position)
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: {
						op: 'onSite',
						visitId: visitId,
						checkIn: checkIn,
						checkOut: checkOut,
						position: position
					}
				}
				return $http(req)
				.then(
					function(result) {
						console.log("onSite result:", result.data);
						return result.data;
					},
					function(error) {
						return errorHandler(error);
					}
				)
			},

			// Call CASDM and check if visit for case id and visitor represented by moblie number is already on-site
			checkOnSite: function (visitor, visitCase, position) {
				console.log("checkOnSite request:", visitor, visitCase, position)
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: {
						op: 'checkOnSite',
						visitor: visitor,
						case: visitCase,
						position: position
					}
				}
				return $http(req)
				.then(
					function(result) {
						console.log("checkOnSite result:", result.data);
						return result.data;
					},
					function(error) {
						return errorHandler(error);
					}
				)
			},

			// Call CASDM and check if visitor should leave site without calling NOC or if the offSite process can be completed by app
			checkOffSite: function (visitor, visitCase, position) {
				console.log("checkOffSite request:", visitor, visitCase, position)
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: {
						op: 'checkOffSite',
						visitor: visitor,
						case: visitCase,
						position: position
					}
				}
				return $http(req)
				.then(
					function(result) {
						console.log("checkOffSite result:", result.data);
						return result.data;
					},
					function(error) {
						return errorHandler(error);
					}
				)
			},

			// Call CASDM to notify off-site
			offSite: function (visitor, checkOut, position) {
				console.log("offSite request:", visitor, checkOut, position)
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: {
						op: 'offSite',
						visitId: visitor.visitId,
						checkOut: checkOut,
						position: position
					}
				}
				return $http(req)
				.then(
					function(result) {
						console.log("offSite result:", result.data);
						return result.data;
					},
					function(error) {
						return errorHandler(error);
					}
				)
			},

			// File bug/error to backend
			reportBug: function (visitor, visitCase, position, client, message, appModule, appName, appVersion) {
				// Make sure message is a plain string.
				if (typeof message === 'object') {
					if (__RPTERRORSTACK__ && message.stack) {
						message = message.stack
					} else {
						message = message.toString()
					}
				};
				var attrs = {
					op: 'reportBug',
					visitor: visitor,
					visitCase: visitCase,
					position: position,
					client: client,
					message: message,
					appModule: appModule,
					appName: appName,
					appVersion: appVersion
				};
				console.log("reportBug:", attrs);
				var req = {
					url: base_url + '/op',
					method: 'POST',
					headers: {'Content-type': 'application/json'},
					responseType: "json",
					data: attrs
				}
				return $http(req)
				.then(
					function(result) {
						console.log("reportBug result:", result.data);
						return result.data;
					},
					function(error) {
						return errorHandler(error);
					}
				)
			}
			
		}
	}])
};
